<template>
    <div class="AddInjuryOnTheJobBox">
        <div class="head">
            <el-breadcrumb style="margin: auto auto auto 20px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'InjuryOnTheJob' }">工伤申报</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px"
                     size="small" style="width: 55%; margin-left: 15%">
                <el-form-item label="申报人姓名" prop="empId">
                    <el-select v-model="ruleForm.empId" style="width: 100%" @change="nameChange">
                        <el-option v-for="item in empList" :key="item.id" :value="item.id" :label="item.name"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="申报人性别" prop="applicantSex">
                    <el-radio-group v-model="ruleForm.applicantSex" size="small">
                        <el-radio-button :label="1">男</el-radio-button>
                        <el-radio-button :label="2">女</el-radio-button>
                        <el-radio-button :label="0">未知</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="申报人部门" prop="applicantDepName">
                    <el-input v-model="ruleForm.applicantDepName"/>
                </el-form-item>
                <el-form-item label="事故名称" prop="accidentBulletinId">
                    <el-select v-model="ruleForm.accidentBulletinId" style="width: 100%" @change="accChange">
                        <el-option v-for="acc in accidentList" :key="acc.id" :value="acc.id" :label="acc.name"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="事故发生时间" prop="accidentTime">
                    <el-date-picker v-model="ruleForm.accidentTime" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="工伤类型" prop="occupationalInjuryType">
                    <el-select v-model="ruleForm.occupationalInjuryType" style="width: 100%">
                        <el-option value="轻微伤" label="轻微伤"/>
                        <el-option value="轻伤" label="轻伤"/>
                        <el-option value="重伤" label="重伤"/>
                        <el-option value="死亡" label="死亡"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="申报日期" prop="declarationTime">
                    <el-date-picker v-model="ruleForm.declarationTime" type="date"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="损失工时" prop="delayTime">
                    <el-input v-model="ruleForm.delayTime" type="number" placeholder="单位小时"/>
                </el-form-item>
                <el-form-item label="就诊医院" prop="clinicHospital">
                    <el-input v-model="ruleForm.clinicHospital"/>
                </el-form-item>
                <el-form-item label="就诊结果">
                    <el-input v-model="ruleForm.diagnosis" type="textarea" :rows="2"/>
                </el-form-item>
                <el-form-item label="注意事项">
                    <el-input v-model="ruleForm.announcements" type="textarea" :rows="2"/>
                </el-form-item>
                <el-form-item label="材料是否齐全" prop="isAllReady">
                    <el-radio-group v-model="ruleForm.isAllReady" size="small">
                        <el-radio-button :label="1">是</el-radio-button>
                        <el-radio-button :label="0">否</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="相关附件">
                    <el-upload
                            class="upload-demo"
                            action="/v1/trainMaterials/uploadFile"
                            :on-remove="handleRemove"
                            :limit="1"
                            :on-exceed="handleExceed"
                            :on-change="handleChange"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="ruleForm.remark" type="textarea" :rows="2"/>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {getStaffList, accidentBulletin, inJuryONJobAdd, inJuryONJobEdit} from '@/api/processManager'

    export default {
        name: 'AddInjuryOnTheJob',
        data() {
            return {
                ruleForm: {},
                rules: {
                    empId: [{required: true, message: '请选择'}],
                    applicantSex: [{required: true, message: '请选择'}],
                    applicantDepName: [{required: true, message: '请选择'}],
                    accidentBulletinId: [{required: true, message: '请选择'}],
                    accidentTime: [{required: true, message: '请选择'}],
                    occupationalInjuryType: [{required: true, message: '请选择'}],
                    declarationTime: [{required: true, message: '请选择'}],
                    delayTime: [{required: true, message: '请输入'}],
                    clinicHospital: [{required: true, message: '请输入'}],
                    isAllReady: [{required: true, message: '请选择'}],
                },
                fileList: [],
                empList: [],
                accidentList: [],
            }
        },
        async created() {
            if (this.$route.params.key) {
                this.ruleForm = this.$route.params.key
                if (this.$route.params.key.fileUrl) {
                    this.fileList.push({
                        name: this.$route.params.key.fileName,
                        response: {data: this.$route.params.key.fileUrl}
                    })
                }
            }
            await this.getEmpList();
            await this.getAccident();
            // console.log(this.ruleForm, this.fileList)
        },
        methods: {
            // 上传的事件
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
            handleChange(file, fileList) {
                this.fileList = fileList
            },
            handleExceed(file, fileList) {
                this.$message.warning('限制上传一个文件')
            },
            // 获取人员列表
            async getEmpList() {
                await getStaffList().then(res => {
                    this.empList = res.body.data
                })
            },
            // 人员改变的事件
            nameChange(id) {
                for (let i in this.empList) {
                    if (this.empList[i].id === id) {
                        this.$set(this.ruleForm, 'applicantName', this.empList[i].name)
                        this.$set(this.ruleForm, 'applicantSex', this.empList[i].sex)
                        this.$set(this.ruleForm, 'applicantDepName', this.empList[i].depName)
                    }
                }
            },
            // 获取事故快报列表
            async getAccident() {
                await accidentBulletin({limit: 1000, curPage: 1}).then(res => {
                    this.accidentList = res.body.data
                })
            },
            // 事故快报改变
            accChange(id) {
                for (let i in this.accidentList) {
                    if (this.accidentList[i].id === id) {
                        this.$set(this.ruleForm, 'accidentBulletinName', this.accidentList[i].name)
                        this.$set(this.ruleForm, 'accidentTime', this.accidentList[i].occurTime)
                    }
                }
            },
            submit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let obj = {...this.ruleForm}
                        if (this.fileList.length > 0) {
                            obj.fileName = this.fileList[0].name
                            obj.fileUrl = this.fileList[0].response.data
                        }
                        // 编辑
                        if (this.$route.params.key) {
                            inJuryONJobEdit(obj).then(res => {
                                this.$message.success('编辑成功')
                                this.$router.push('InjuryOnTheJob')
                            })
                        }
                        // 新增
                        else {
                            inJuryONJobAdd(obj).then(res => {
                                this.$message.success('新增成功')
                                this.$router.push('InjuryOnTheJob')
                            })
                        }
                    } else {
                        return false
                    }
                })
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    }
</script>

<style scoped>
    .AddInjuryOnTheJobBox /deep/ .el-form-item {
        margin-bottom: 25px
    }
</style>
